var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-scroll-board',{staticStyle:{"height":"calc(24vh - 110px)"},attrs:{"config":_vm.charge_logs}})
}
var staticRenderFns = []

export { render, staticRenderFns }